import { render, staticRenderFns } from "./UploadViolationAttachments.vue?vue&type=template&id=75003622&"
import script from "./UploadViolationAttachments.vue?vue&type=script&lang=ts&"
export * from "./UploadViolationAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
